import script from "./ReservationsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationsChart.vue?vue&type=script&setup=true&lang=js"

import "./ReservationsChart.vue?vue&type=style&index=0&id=59659f46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59659f46"]])

export default __exports__